import { render, staticRenderFns } from "./StokYonetimi.vue?vue&type=template&id=a65cedf2"
import script from "./StokYonetimi.vue?vue&type=script&lang=js"
export * from "./StokYonetimi.vue?vue&type=script&lang=js"
import style0 from "./StokYonetimi.vue?vue&type=style&index=0&id=a65cedf2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports